export default {
  lang: {
    export: 'Pag-exporto',
    successfully: 'Naging matagumpay ang pag-export ng gawain',
    pleaseJumpTo: 'Mangyaring jump',
    uploadAndDownloadCenter: 'Upload at Download Center.',
    check: 'Pansing',
    exportAll: 'Tikumpirma upang i-export ang lahat ng nilalaman?',
    total: 'Kabuan',
    confirm: 'Data, konfirma ang pag-export?',
    error: 'Ang dami ng data ay 0, mangyaring baguhin ang mga kriter ng filter at subukan mulin',
  },
};
